import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService } from './converter.service';
import { getChatApiBaseUrl } from '../../utils/getChatApiBaseUrl';
import { getDefaultRequestHeaderParams } from '../../utils/getRequestHeaderParams';
import { getBrand } from '../../utils/getBrand';

@Injectable({
  providedIn: 'root',
})
export class VaDialogService {
  constructor(
    private http: HttpClient,
    private converterService: ConverterService
  ) {}

  sendChatMessage({
    query = '',
    sessionId = '',
    addressId = '',
    addedObject = {},
  }): Observable<Message[]> {
    return (<Observable<ApiSendChatMessageResponse>>this.http.post(
      getChatApiBaseUrl() + getBrand().dialogApi,
      Object.assign({ query, addressId }, addedObject),
      {
        headers: {
          ...getDefaultRequestHeaderParams({
            'session-identifier': sessionId,
          }),
        },
        withCredentials: true,
      }
    )).pipe(map(this.converterService.convertSendChatMessageResponse));
  }
}
